// Skeleton.js
import React from 'react';
import '../assets/css/skeleton.css'; // You can style your skeleton with CSS

const SkeletonComponent = () => {
  return (
    <div className='skeleton'>
      <div className='skeleton-image'></div>
      <div className='skeleton-text'></div>
      <div className='skeleton-price'></div>
    </div>
  );
}

export default SkeletonComponent;
